import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { generatePurchaseReport } from 'Services/JOONAdmin/joonAdminReportsService'

import { QueryNames } from 'Hooks/api/queryNames'

import { Employer } from 'Utils/types/JOONAdmin/employer'
import { formatDateForServer } from 'Utils/helpers/dateUtils'
import { CountryCode } from 'Utils/types/countries'

export const useGeneratePurchaseReport = () =>
  useMutation(
    [QueryNames.GeneratePurchaseReport],
    async ({
      employerId,
      date,
      countryCode
    }: {
      employerId: Employer['id']
      date: Date
      countryCode: CountryCode
    }) => {
      const dateString = formatDateForServer(date)
      const response = await generatePurchaseReport(employerId, dateString, countryCode)
      if (response.success) {
        toast.success('Purchase report is being regenerated in Google Drive')
      } else {
        toast.error(response.message || 'Failed to regenerate purchase report')
      }
    },
    {
      onError: () => {
        toast.error('Failed to regenerate purchase report')
      }
    }
  )
